<template>
  <span>
    <h1 class="font-semibold text-xl">Sales By Location</h1>
    <SalesByLocation />
  </span>
</template>

<script>
import SalesByLocation from '../component/includes/one_quarter/SalesByLocationComponent.vue';

export default {
  components: {
    SalesByLocation,
  },
};
</script>

<style scoped>

</style>
